import React from 'react'

const CheckIcon = (props: any = {}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={props?.size ?? 12} height={props?.size ?? 12} viewBox="0 0 12 12" fill="none">
            <rect x="3" y="2.40002" width="6" height="7.2" fill="white" />
            <path fillRule="evenodd" clipRule="evenodd" d="M11 6.00006C11 8.76149 8.76142 11.0001 6 11.0001C3.23858 11.0001 1 8.76149 1 6.00006C1 3.23864 3.23858 1.00006 6 1.00006C8.76142 1.00006 11 3.23864 11 6.00006ZM8.01516 4.4849C8.16161 4.63134 8.16161 4.86878 8.01516 5.01523L5.51517 7.51523C5.36872 7.66167 5.13128 7.66167 4.98483 7.51523L3.98483 6.51523C3.83839 6.36878 3.83839 6.13134 3.98483 5.9849C4.13128 5.83845 4.36872 5.83845 4.51517 5.9849L5.25 6.71973L6.36742 5.60231L7.48483 4.4849C7.63128 4.33845 7.86872 4.33845 8.01516 4.4849Z" fill={props?.color ?? "var(--success)"} />
        </svg>
    )
}

export default CheckIcon